import { SuperAdminConstants } from '../../../_constants';

const initialState = { analyticsOrganisationLoading: true, data: '', error: false };

export function getAnalyticsOrganisationReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ANALYTICS_ORGANISATION:
            return {
                analyticsOrganisationLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ANALYTICS_ORGANISATION:
            return {
                analyticsOrganisationLoading: false,
                data: action.analyticsOrganisation,
                error: false
            };
        case SuperAdminConstants.GET_ANALYTICS_ORGANISATION_ERROR:
            return {
                analyticsOrganisationLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AddOrganisation/getAnalyticsOrganisation.reducer.js